import React from 'react';

import { Calculate } from 'components/sections/Calculate';
import { LoanType } from 'enums/LoanType';
import { CompanySoftCalculator } from 'components/CompanySoftCalculator';
import { ReleaseCalculator } from 'components/ReleaseCalculator';

import styles from './ArticleCalculator.module.scss';

const calculatorTypes = {
  private: <Calculate hideHeadline hideImage loanType={LoanType.NordeaLoan} />,
  company: <CompanySoftCalculator />,
  're-lease': <ReleaseCalculator partner="ref" />,
};

interface Props {
  calculatorType: string;
}
export const ArticleCalculator: React.FC<Props> = ({ calculatorType }) => (
  <aside className={styles.wrapper}>
    <div className={styles.content}>{calculatorTypes[calculatorType] || null}</div>
  </aside>
);
